var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPhone(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30.067,
    viewBox: "0 0 30 30.067",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_3197",
    "data-name": "Path 3197",
    d: "M483.04,3164a3.642,3.642,0,0,1,1.644.714c.067.057.138.11.2.172,1.35,1.348,2.706,2.691,4.046,4.05a2.827,2.827,0,0,1,.468,3.548,2.516,2.516,0,0,1-1.335,1.092,2.953,2.953,0,0,0-1.824,1.629,2.5,2.5,0,0,0-.116,1.69,9.915,9.915,0,0,0,2.243,3.941,13.605,13.605,0,0,0,4.266,3.392,3.808,3.808,0,0,0,2.219.527,2.7,2.7,0,0,0,2.294-1.681,3.114,3.114,0,0,1,1.254-1.643,2.772,2.772,0,0,1,3.278.285c.823.751,1.6,1.558,2.384,2.348.719.719,1.463,1.418,2.133,2.182a2.889,2.889,0,0,1,.123,3.514,4.965,4.965,0,0,1-.508.6c-.791.8-1.607,1.577-2.381,2.394a4.2,4.2,0,0,1-3.012,1.3,9.929,9.929,0,0,1-3.62-.623,24.435,24.435,0,0,1-6.363-3.4,41.332,41.332,0,0,1-8.6-8.274,26.316,26.316,0,0,1-4.334-7.643,10.139,10.139,0,0,1-.635-3.8,4.16,4.16,0,0,1,1.29-2.957c.718-.679,1.415-1.381,2.1-2.1a3.62,3.62,0,0,1,2.145-1.27Z",
    transform: "translate(-476.852 -3164.004)",
    fill: "#8a8a8a"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.f887bf33cc703e2fcab2e61613317b34.svg";
export { ForwardRef as ReactComponent };